import { combineReducers } from 'redux';
import { homeReducer } from './home'
import { metaReducer } from './meta'
import { mobileReducer } from './mobile'
// import { menuReducer } from './menu'

import ZasedaniyaPravleniyaFederatsii from '../objects/ZasedaniyaPravleniyaFederatsii/reducer'
import VPDZasedaniyaPravleniyaFederatsii from '../objects/VPDZasedaniyaPravleniyaFederatsii/reducer'
import DokumentPrisutstvuyushchieNaZasedaniiPravleniyaFederatsii from '../objects/DokumentPrisutstvuyushchieNaZasedaniiPravleniyaFederatsii/reducer'
import ResheniePoVoprosuPovestkiDnyaZasedaniyaPravleniyaFederatsii from '../objects/ResheniePoVoprosuPovestkiDnyaZasedaniyaPravleniyaFederatsii/reducer'

import ZasedaniyaRegionalnogoPravleniya from '../objects/ZasedaniyaRegionalnogoPravleniya/reducer'
import VPDZasedaniyaRegPravleniya from '../objects/VPDZasedaniyaRegPravleniya/reducer'
import DokumentPrisutstvuyushchieNaZasedaniiRegPravleniya from '../objects/DokumentPrisutstvuyushchieNaZasedaniiRegPravleniya/reducer'
import ResheniePoVoprosuPovestkiDnyaZasedaniyaRegPravleniya from '../objects/ResheniePoVoprosuPovestkiDnyaZasedaniyaRegPravleniya/reducer'
import Pari from '../objects/Pari/reducer'
import KontaktiFederatsii from '../objects/KontaktiFederatsii/reducer'
import TipiTelefonov from '../objects/TipiTelefonov/reducer'
import Region from '../objects/Region/reducer'
import City from '../objects/City/reducer'
import SotsSeti from '../objects/SotsSeti/reducer'
import RegionalnieOtdeleniya from '../objects/RegionalnieOtdeleniya/reducer'
import VseTipiPolzovatelei from '../objects/VseTipiPolzovatelei/reducer'
import Meropriyatiya from '../objects/Meropriyatiya/reducer'
import TipiMeropriyatii from '../objects/TipiMeropriyatii/reducer'
import UrovenMeropriyatiya from '../objects/UrovenMeropriyatiya/reducer'
import TekushchieStatusiMeropriyatii from '../objects/TekushchieStatusiMeropriyatii/reducer'
import KategoriiUchastnikov from '../objects/KategoriiUchastnikov/reducer'
import TantsevalnieDistsiplini from '../objects/TantsevalnieDistsiplini/reducer'
import TipiSsilokNaFaili from '../objects/TipiSsilokNaFaili/reducer'
import TipiSsilokVSotsSetyakh from '../objects/TipiSsilokVSotsSetyakh/reducer'
import KomissiiPartneram from '../objects/KomissiiPartneram/reducer'
import KakVichislitAkkaunt from '../objects/KakVichislitAkkaunt/reducer'
import Promokodi from '../objects/Promokodi/reducer'
import YacheikiUslugi from '../objects/YacheikiUslugi/reducer'
import Akkaunti from '../objects/Akkaunti/reducer'
import KomissiiVYacheikakh from '../objects/KomissiiVYacheikakh/reducer'
import StatusiPokupatelya from '../objects/StatusiPokupatelya/reducer'
import VidiUslugNaMeropriyatii from '../objects/VidiUslugNaMeropriyatii/reducer'
import TipiTarifov from '../objects/TipiTarifov/reducer'
import AkkauntiPolzovatelei from '../objects/AkkauntiPolzovatelei/reducer'
import Protocol from '../objects/Protocol/reducer'

import UserConfig from '../objects/UserConfig/reducer'
import Translate from '../objects/Translate/reducer'

import { siteAccessReducer } from './siteAccess';

const rootReducer = combineReducers({
    meta: metaReducer,
    mobile: mobileReducer,
    // menu: menuReducer,
    home: homeReducer,
    siteAccess: siteAccessReducer,
    Pari: Pari.reducer,
    KontaktiFederatsii: KontaktiFederatsii.reducer,
    TipiTelefonov: TipiTelefonov.reducer,
    Region: Region.reducer,
    City: City.reducer,
    SotsSeti: SotsSeti.reducer,
    RegionalnieOtdeleniya: RegionalnieOtdeleniya.reducer,
    VseTipiPolzovatelei: VseTipiPolzovatelei.reducer,

    ZasedaniyaPravleniyaFederatsii: ZasedaniyaPravleniyaFederatsii.reducer,
    VPDZasedaniyaPravleniyaFederatsii: VPDZasedaniyaPravleniyaFederatsii.reducer,
    DokumentPrisutstvuyushchieNaZasedaniiPravleniyaFederatsii: DokumentPrisutstvuyushchieNaZasedaniiPravleniyaFederatsii.reducer,
    ResheniePoVoprosuPovestkiDnyaZasedaniyaPravleniyaFederatsii: ResheniePoVoprosuPovestkiDnyaZasedaniyaPravleniyaFederatsii.reducer,

    ZasedaniyaRegionalnogoPravleniya: ZasedaniyaRegionalnogoPravleniya.reducer,
    VPDZasedaniyaRegPravleniya: VPDZasedaniyaRegPravleniya.reducer,
    DokumentPrisutstvuyushchieNaZasedaniiRegPravleniya: DokumentPrisutstvuyushchieNaZasedaniiRegPravleniya.reducer,
    ResheniePoVoprosuPovestkiDnyaZasedaniyaRegPravleniya: ResheniePoVoprosuPovestkiDnyaZasedaniyaRegPravleniya.reducer,
    Meropriyatiya: Meropriyatiya.reducer,
    TipiMeropriyatii: TipiMeropriyatii.reducer,
    UrovenMeropriyatiya: UrovenMeropriyatiya.reducer,
    TekushchieStatusiMeropriyatii: TekushchieStatusiMeropriyatii.reducer,
    KategoriiUchastnikov: KategoriiUchastnikov.reducer,
    TantsevalnieDistsiplini: TantsevalnieDistsiplini.reducer,
    TipiSsilokNaFaili: TipiSsilokNaFaili.reducer,
    TipiSsilokVSotsSetyakh: TipiSsilokVSotsSetyakh.reducer,
    KomissiiPartneram: KomissiiPartneram.reducer,
    KakVichislitAkkaunt: KakVichislitAkkaunt.reducer,
    Promokodi: Promokodi.reducer,
    YacheikiUslugi: YacheikiUslugi.reducer,
    Akkaunti: Akkaunti.reducer,
    KomissiiVYacheikakh: KomissiiVYacheikakh.reducer,
    StatusiPokupatelya: StatusiPokupatelya.reducer,
    VidiUslugNaMeropriyatii: VidiUslugNaMeropriyatii.reducer,
    TipiTarifov: TipiTarifov.reducer,
    AkkauntiPolzovatelei: AkkauntiPolzovatelei.reducer,
    Protocol: Protocol.reducer,

    UserConfig: UserConfig.reducer,
    Translate: Translate.reducer,
});

export default rootReducer;